var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "dropdown",
    _vm._b(
      {
        staticClass: "search-input",
        model: {
          value: _vm.dropdownOptions.value,
          callback: function($$v) {
            _vm.$set(_vm.dropdownOptions, "value", $$v)
          },
          expression: "dropdownOptions.value"
        }
      },
      "dropdown",
      _vm.dropdownOptions,
      false
    ),
    [
      _c("div", { staticClass: "search-input__trigger" }),
      _vm._v(" "),
      _c(
        "input",
        _vm._b(
          {
            ref: "inputElement",
            staticClass: "form-control no_border m-b-0 p-r-3",
            attrs: { type: "text", name: "name", autocomplete: "off" },
            domProps: { value: _vm.value },
            on: {
              click: function($event) {
                $event.preventDefault()
              },
              keydown: [
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "down", 40, $event.key, [
                      "Down",
                      "ArrowDown"
                    ])
                  )
                    return null
                  $event.preventDefault()
                  return _vm.selectNext.apply(null, arguments)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "up", 38, $event.key, [
                      "Up",
                      "ArrowUp"
                    ])
                  )
                    return null
                  $event.preventDefault()
                  return _vm.selectPrev.apply(null, arguments)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  $event.preventDefault()
                  return _vm.onKeySelect.apply(null, arguments)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                  )
                    return null
                  $event.preventDefault()
                  return _vm.onKeySelect.apply(null, arguments)
                }
              ],
              input: function($event) {
                return _vm.$emit("input", $event.target.value)
              },
              blur: _vm.hidePopover
            }
          },
          "input",
          _vm.$attrs,
          false
        )
      ),
      _vm._v(" "),
      _c("template", { slot: "dropdown" }, [
        _c("div", { staticClass: "rb-tags-input" }, [
          _c(
            "ul",
            { ref: "dropdownList", staticClass: "dropdown" },
            _vm._l(_vm.filteredDatalist, function(item, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "uib-typeahead-match",
                  class: { active: index === _vm.activeIndex },
                  attrs: { role: "option" }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "ng-binding ng-scope",
                      attrs: {
                        draggable: "false",
                        href: "",
                        tabindex: "-1",
                        title: item
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.$emit("input", item)
                        }
                      }
                    },
                    [_vm._v("\n            " + _vm._s(item) + "\n          ")]
                  )
                ]
              )
            }),
            0
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }